// Only callers explicitly bound to a State report context opt in. There is no global/ambient report mode.
export class StaleStateReport extends Error {}

function copyParameters(data, restriction_only) {
	if (data instanceof FormData || data instanceof URLSearchParams) {
		const copy = data instanceof FormData ? new FormData() : new URLSearchParams();
		for (const [key, value] of data.entries()) if (key !== 'restriction_only') copy.append(key, value);
		if (restriction_only) copy.set('restriction_only', 'true');
		return copy;
	}
	const copy = { ...data };
	delete copy.restriction_only;
	if (restriction_only) copy.restriction_only = true;
	return copy;
}

export async function stateReportRequest(context, api, method, url, data, config) {
	if (!context || !context.state_report_id || !context.$session.get('user') || context.$session.get('user').company_id !== 'beautyplus') {
		if (method === 'get') return arguments.length < 5 ? api.get(url) : api.get(url, data);
		return config === undefined ? api.post(url, data) : api.post(url, data, config);
	}
	const sequence = context.state_report_sequence;
	const restriction_only = context.restriction_only_available && (context.state_report_request ? context.state_report_request.restriction_only : context.state_scope_read_only);
	let response;
	if (method === 'get') {
		const options = { ...data };
		options.params = copyParameters(options.params, restriction_only);
		// Query parameters always use the exact string form, even when the caller used a plain object.
		if (restriction_only && !(options.params instanceof URLSearchParams)) options.params.restriction_only = 'true';
		response = await api.get(url, options);
	} else {
		response = await api.post(url, copyParameters(data, restriction_only), config);
	}
	if (sequence !== context.state_report_sequence) throw new StaleStateReport();
	const read_only = (response.data && response.data.state_scope_read_only === true) || (response.headers && response.headers['x-state-scope-read-only'] === 'true');
	if (restriction_only && !read_only) throw new StaleStateReport('State access changed. Search again.');
	context.state_report_response_read_only = !!read_only;
	return response;
}
